<template>
  <div class="page_wrap page_wrap_contact">
    <component v-bind:is="headerComponent"></component>
    <div class="row-container mt5 ph3">
      <h1 class="contact_title">{{$t('submitRequestTitle')}}</h1>
      <form v-on:submit.prevent="handleSubmit" class="form pb2">
        <div class="input-group">
          <label class="label" for="email">
            {{$t('yourEmailAddressText')}}
            <span class="red">*</span>
          </label>
          <input
            name="email"
            class="input"
            type="text"
            id="email"
            v-model="email"
            aria-required="true"
            >
            <div :class="errEmail" id="email-err" class="notification notification-error notification-inline" style="padding:10px 15px 35px 15px;">
              {{inputErr.email}}
            </div>
        </div>

        <div class="input-group">
          <label class="label" for="subject">
            {{$t('subjectText')}}
            <span class="red">*</span>
          </label>
          <input
            v-on:keyup.prevent="searchArticles"
            id="subject"
            type="text"
            class="input"
            v-model="subject"
            aria-required="true"
            >
            <div id="subject-err" :class="errSubject" class="notification notification-error notification-inline" style="padding:10px 15px 35px 15px;">
              {{inputErr.subject}}
            </div>
        </div>
        <div class="input-group">
          <label class="label" for="articles">
            {{$t('helpWithText')}}
            <span class="red">*</span>
          </label>
          <select v-model="article" id="articles" class="input">
            <option :value="$store.getters.flowObject.variables.popularQuestions[2]">{{$t('popQues4')}}</option>
            <option :value="$store.getters.flowObject.variables.popularQuestions[0]">{{$t('popQues1')}}</option>
            <option :value="$store.getters.flowObject.variables.popularQuestions[1]">{{$t('popQues2')}}</option>
            <option value="none">{{$t('noValueArticleSelectText')}}</option>
          </select>
        </div>
        <transition name="fade" v-if="article">
          <Article :articleIdProp="article"/>
        </transition>
        <div class="input-group">
          <label class="label" for="description">
            {{$t('requestDescriptionText')}}
            <span class="red">*</span>
          </label>
          <textarea
            name="description"
            id="description"
            class="textarea"
            aria-required="true"
            v-model="description"
            aria-describedby="request_description_hint"
            >
          </textarea>
          <div :class="errDescription" id="description-err" class="notification notification-error notification-inline" style="padding:10px 15px 35px 15px;">
              {{inputErr.description}}
          </div>
          <p class="input-group__fineprint">{{$t('requestFormPlaceholder')}}</p>
        </div>

        <div class="input-group file-upload-vpn">
          <label class="label" for="file-upload">{{$t('requestAttachmentsText')}}</label>
          <component v-bind:is="fileUploadComponent"></component>
        </div>

        <div class="input-group input-group--btns">
          <button
            :disabled="loading"
            id="submit"
            @click="trackPageClick('submit_request_attempt')"
            class="btn"
            type="submit"
          >{{$t('requestSubmitText')}}</button>
        </div>
        <button
          style="visibility: hidden;"
          id="recaptcha"
          class="g-recaptcha"
          v-bind="{
            'data-sitekey':`${siteKey}`,
            'data-callback': `myRecaptchaHandler`,
            'data-badge': 'inline'
            }"
        ></button>
        <div
          id="recaptcha-error"
          class="notification notification-error notification-inline"
          style="padding: 10px 15px 35px;color: red;display: none;"
        >{{errorMessage}}</div>
      </form>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import Article from '@/components/article/zen_no_title';

import {
  searchLocalArticles,
  formatArticleTitles,
  getComponent,
  handleRequestSubmit,
  trackPageView,
  trackPageClick,
  getPageHash
} from '@/utils/common';

export default {
  name: 'requests',
  data() {
    return {
      email: '',
      description: '',
      subject: '',
      article: '',
      errorMessage: '',
      queryResults: [],
      siteKey: process.env.RECAPTCHA_SITEKEY,
      inputErr: {
        email: '',
        description: '',
        subject: ''
      },
      loading: null,
      errDisplay: {
        email: false,
        description: false,
        subject: false
      }
    };
  },
  created() {
    trackPageView('submit_request');
  },
  mounted() {
    window.grecaptcha.render('recaptcha');
    // the handler for the captcha is defined on a property therefore it wont have access to this scope
    window.myRecaptchaHandler = this.recaptchaSucces;
  },
  metaInfo() {
    return {
      titleTemplate: `${this.$t('requestTitle')} - %s `
    };
  },
  components: { VueRecaptcha, Article },
  computed: {
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    articleComponent() {
      return getComponent(this.$store.getters.flowObject, 'article_no_title');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    },
    fileUploadComponent() {
      return getComponent(this.$store.getters.flowObject, 'fileUpload');
    },
    errEmail() {
      return {
        'hide-err': !this.errDisplay.email,
        'show-err': this.errDisplay.email
      };
    },
    errDescription() {
      return {
        'hide-err': !this.errDisplay.description,
        'show-err': this.errDisplay.description
      };
    },
    errSubject() {
      return {
        'hide-err': !this.errDisplay.subject,
        'show-err': this.errDisplay.subject
      };
    }
  },
  methods: {
    getHash(article) {
      return getPageHash(article);
    },
    recaptchaSucces() {
      this.clearErrors();
      this.loading = true
      handleRequestSubmit(this.email, this.subject, this.description, this.article).then(response => {
        this.email = '';
        this.subject = '';
        this.description = '';
        document.getElementById('recaptcha-error').style.display = 'none';
        this.loading = false;
        this.$router.push({ path: 'home', query: { request: 'success' } });
      }).catch(error => {
        this.loading = false;
        if (error.response && error.response.data.message === 'reCaptcha authentication failed') {
          this.displayGeneralError(this.$t('requestCaptchaFailed'));
          window.grecaptcha.reset();
        } else if (error.message === 'file upload still in progress') {
          this.displayGeneralError(this.$t('requestUploadInProgress'));
        } else if ((error.response && error.response.data.message === 'invalid email address') || error === 'invalid email address') {
          this.inputErr.email = this.$t('invalidEmail');
          this.errDisplay.email = true;
          document.getElementById('email').focus();
        } else if (error.message === 'missing fields') {
          error.fields.forEach(field => {
            this.inputErr[field] = this.$t(`zendesk-missing-${field}`);
            this.errDisplay[field] = true;
            document.getElementById(`${field}`).focus();
          });
        } else {
          this.displayGeneralError(this.$t('requestErrorMessage'));
        }
      });
    },
    displayGeneralError(message) {
      let errorEl = document.getElementById('recaptcha-error');
      this.errorMessage = message;
      errorEl.style.display = 'block';
      errorEl.focus();
    },
    handleSubmit() {
      if (window.grecaptcha.getResponse() === '') {
        return window.grecaptcha.execute();
      }
      this.recaptchaSucces();
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    },
    searchArticles() {
      if (this.subject && this.subject.length > 2) {
        let query = this.subject.replace(/\+/g, ' ');
        const queries = query.split(' ').map(query => new RegExp(`(${query})`, 'i'));
        this.articles = searchLocalArticles(queries);
        const suggestions = formatArticleTitles(this.articles, query);
        this.queryResults = suggestions;
      } else if (this.subject.length < 3) {
        this.queryResults = [];
      }
    },
    clearErrors() {
      document.getElementById('recaptcha-error').style.display = 'none';
      this.errDisplay = {
        email: false,
        description: false,
        subject: false
      };
      this.inputErr = {
        email: '',
        description: '',
        subject: ''
      };
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/trusted_vpn-design.scss';
.contact_title {
  margin-bottom: 1rem;
  font-size: 32px;
  font-family: 'Montserrat', sans-serif;
  font-style: italic;
  font-weight: 700;
  color: #18214F;
  text-align: center;
}
.form {
  max-width: 650px;
  margin: 0 auto;
}
.input-group {
  margin-bottom: 25px;

  .btn {
    background-color: #3E3EFF;
    border: 0;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 2.72;
    min-width: 190px;
    padding: 0 1.9286em;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    transition: border 0.12s ease-in-out;
    cursor: pointer;

    @media (min-width: 768px) {
      width: auto;
    }
    &:hover,
    &:focus,
    &:active {
      background-color: #3E3EFF;
    }
  }
}
.input-group--btns {
  margin-top: 40px;
  padding-top: 30px;
}
.label {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
}
.input {
  border: 1px solid #ddd;
  border-radius: 4px;
  max-width: 100%;
  box-sizing: border-box;
  outline: none;
  transition: border 0.12s ease-in-out;
  font-size: 14px;
}
.textarea {
  border: 1px solid #ddd;
  border-radius: 2px;
  resize: vertical;
  width: 100%;
  outline: none;
  min-height: 120px;
}
.input,
.textarea {
  width: 100%;
  color: #000;
  font-size: 14px;
  padding: 10px;

  &:focus {
    border: 1px solid #3E3EFF;
  }
}
.input-group__fineprint {
  color: #676767;
  font-size: 12px;
  margin: 5px 0;
}

.searchbox {
  font-size: 13px;
  color: #676767;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.sug-label {
  border-bottom: 1px solid #ddd;
  display: block;
  padding-bottom: 5px;
}

ul {
  list-style: none;
  padding-left: 0px;
}
.suggestion-list li {
  padding: 10px 0;
  box-sizing: border-box;
  a {
    text-decoration: none;
    color: #3E3EFF;
    background-color: transparent;
  }
}
.fade-enter-active{
  transition: opacity 0.7s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.notification-inline.notification-error {
  background-color: #f4dfde;
  border: 1px solid #e03b30;
  color: #e03b30;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 15px 0px !important;
  transition: height .2s;
  width: 100%;
  color: #555;
}
.notification-inline {
  border-radius: 4px;
  font-weight: 100;
  line-height: 14px;
  margin-top: 5px;
  padding: 5px;
  position: relative;
  text-align: left;
  vertical-align: middle;
}
.notification-error {
  background: #ffeded;
}
.notification-inline.notification-error::before {
  border-radius: 50%;
  border: 1px solid #e03b30;
  color: #e03b30;
  content: "!";
  display: inline-block;
  font-family: sans-serif;
  font-size: 8px;
  font-weight: normal;
  height: 12px;
  line-height: 12px;
  margin: -2px 5px 0 0;
  text-align: center;
  vertical-align: middle;
  width: 12px;
}
.flc::first-letter {
  text-transform: uppercase; /* change first letter to uppercase */
}
.show-err {
  display: block;
}
.hide-err {
  display: none;
}

</style>
